module.exports = __webpack_public_path__ + "media/images/users_voice008-dba7b0b1a18fa67905d8bda9baa81807.jpg";